import teethCleaningImg from "../../assets/servicesNewPage/teeth_cleaning.jpg";
import dentalImplantImg from "../../assets/servicesNewPage/Dental_implant.jpg";
import rootCanalImg from "../../assets/servicesNewPage/root_canal_treatment.jpg";
import crownsBridgesImg from "../../assets/servicesNewPage/crown_and_bdiges_thumbnail.jpg";
import denturesImg from "../../assets/servicesNewPage/COMPLETE_DENTURES.jpg";
import bracesAlignersImg from "../../assets/servicesNewPage/BRACES_AND_ALIGNERS.jpg";
import teethExtractionImg from "../../assets/servicesNewPage/teeth_extraction.jpg";
import teethFillingImg from "../../assets/servicesNewPage/filingImage.jpg";
import pediatricImg from "../../assets/servicesNewPage/pediatric_dentistry.jpg";
import teethWhiteningImg from "../../assets/servicesNewPage/TeeTh_Whitening.jpg";
import cosmeticImg from "../../assets/servicesNewPage/COSMETIC_DENTISTRY_AND_SMILE_MAKEOVERS.jpg";
import fullMouthRehabImg from "../../assets/servicesNewPage/full_mouth_rehab.jpg";
import digitalDentistryImg from "../../assets/servicesNewPage/Digital_dentistry.jpg";
import laserDentistryImg from "../../assets/servicesNewPage/laser_dentistry.jpg";

const ServiceDetailsData = [
  {
    id: 1,
    title: "Teeth Cleaning",
    slug: 'teeth-cleaning',
    image: teethCleaningImg,
    description: `A professional teeth cleaning is one of the most effective ways to maintain a healthy, radiant
                  smile. Despite regular brushing and flossing, plaque and tartar can accumulate in hard-to-reach
                  areas, increasing the risk of cavities, gum disease, and bad breath. During your cleaning
                  appointment, our skilled dental team gently removes these deposits and polishes your teeth to
                  restore their natural shine. At our clinic, we follow the highest hygiene standards and take every
                  measure to ensure your comfort throughout the procedure. By scheduling regular cleanings —
                  typically every six months — you can keep your teeth strong, your gums healthy, and your smile
                  bright and confident for years to come.`,
  },
  {
    id: 2,
    title: "Dental Implants",
    slug: 'dental-implants',
    image: dentalImplantImg,
    description: ` A dental implants is a long-lasting and natural-looking solution for replacing missing teeth and
restoring your smile. Implants act as artificial tooth roots, providing a strong and stable
foundation for crowns, bridges, or dentures. They not only improve your appearance but also
help maintain jawbone strength and prevent the shifting of surrounding teeth. During your
treatment, our experienced dental team ensures a safe, precise, and comfortable procedure
using advanced techniques and strict sterilization protocols. At our clinic, we are committed to
making your implant experience smooth and stress-free, helping you regain full confidence in
your smile and the ability to eat, speak, and laugh with ease.`,
  },
  {
    id: 3,
    title: "Root Canal Treatment",
    slug: 'root-canal-treatment',
    image: rootCanalImg,
    description: `A root canal treatment is a highly effective procedure designed to save a damaged or infected
        tooth and relieve pain while preserving your natural smile. When the inner pulp of a tooth
        becomes infected due to decay or injury, a root canal removes the infection, cleans the inside of
        the tooth, and seals it to prevent future problems. Our skilled dental team performs this
        treatment with advanced technology and gentle techniques to ensure a safe, precise, and
        comfortable experience, and helping you restore your tooth’s health, function, and strength
        without the need for extraction.`,
  },
  {
    id: 4,
    title: "Crowns and Bridges",
    slug: 'crowns-and-bridges',
    image: crownsBridgesImg,
    description: ` Crowns and bridges are reliable restorative treatments that help rebuild and enhance your
      smile by replacing damaged or missing teeth. A dental crown covers and protects a weakened
      tooth, restoring its shape, strength, and appearance, while a bridge fills the gap left by one or
      more missing teeth using natural-looking artificial teeth anchored to adjacent teeth or implants.
      These restorations not only improve your smile’s appearance but also restore proper chewing
      function and prevent other teeth from shifting. At our clinic, we use high-quality materials and
      precise techniques to ensure a perfect fit, long-lasting results, and a comfortable experience.`,
  },
  {
    id: 5,
    title: "Complete Dentures",
    slug: 'complete-dentures',
    image: denturesImg,
    description: `Complete dentures offer a practical and aesthetic solution for those who have lost all their
natural teeth, helping you regain both function and confidence. Designed to fit the unique
contours of your mouth, they restore your ability to chew, speak clearly, and smile naturally,
while also supporting your facial structure for a balanced, youthful look. At our clinic, we focus
on precision and comfort, using high-quality materials and advanced techniques to ensure your
dentures feel secure and look completely natural.`,
  },
  {
    id: 6,
    title: "Braces and Clear Aligners",
    slug: 'braces-clear-aligners',
    image: bracesAlignersImg,
    description: `Braces and clear aligners are two advanced orthodontic options we offer to help you achieve
a straight, healthy, and confident smile. Traditional braces use brackets and wires to gently
guide your teeth into proper alignment, while clear aligners provide a discreet, removable
alternative that fits seamlessly into your lifestyle. At our clinic, we offer both options and create
personalized treatment plans to determine the best solution for your unique needs, ensuring
effective results while prioritizing comfort. By improving both the appearance and function of
your teeth, these treatments make oral hygiene easier and reduce the risk of dental problems
caused by misalignment. With our expert care we guide you step by step toward a beautifully
aligned, healthy smile.`,
  },
  {
    id: 7,
    title: "Teeth Extraction",
    slug: 'teeth-extraction',
    image: teethExtractionImg,
    description: `Teeth extraction is a safe and effective procedure to remove a damaged, decayed, or
problematic tooth that cannot be restored. Whether it’s due to severe decay, infection,
overcrowding, or impacted wisdom teeth, removing the tooth can prevent further oral health
issues and relieve discomfort. At our clinic, we perform extractions using gentle techniques and
modern equipment to ensure a smooth and comfortable experience. We follow strict hygiene
protocols and provide personalized aftercare guidance to promote fast healing and minimize
discomfort. Our goal is to make the procedure as stress-free as possible while helping you
maintain a healthy, pain-free smile.`,
  },
  {
    id: 8,
    title: "Teeth Filling",
    slug: "teeth-filling",
    image: teethFillingImg,
    description: `Dental teeth fillings are a common and effective treatment to restore teeth damaged by decay or
minor fractures, helping to preserve their strength and function. During the procedure, the
decayed portion of the tooth is carefully removed and filled with a durable, tooth-colored
material that blends seamlessly with your natural teeth. At our clinic, we use advanced
techniques and high-quality materials to ensure your fillings are long-lasting, comfortable, and
aesthetically pleasing.`,
  },
  {
    id: 9,
    title: "Pediatric Dentistry",
    slug: 'pediatric-dentistry',
    image: pediatricImg,
    description: `Pediatric dentistry focuses on providing gentle, compassionate, and comprehensive dental
care for children from infancy through adolescence. Regular checkups, cleanings, fluoride
treatments, and preventive care help establish healthy oral habits early, while addressing issues
like cavities, early orthodontic needs, and gum health. At our clinic, we create a friendly,
welcoming environment designed to make children feel comfortable and at ease during every
visit. Our team is trained in child-specific techniques, ensuring each appointment is educational,
positive, and tailored to support a lifetime of healthy smiles.`,
  },
  {
    id: 10,
    title: "Teeth Whitening",
    slug: 'teeth-whitening',
    image: teethWhiteningImg,
    description: `Teeth whitening is a quick, safe, and effective way to brighten your smile and boost your
confidence. Over time, teeth can become stained or discolored due to coffee, tea, smoking, or
aging. Our professional whitening treatments gently lift these stains, restoring your teeth’s
natural brightness in just one visit. At our clinic, we use advanced whitening systems that deliver
noticeable results while being gentle on your enamel and gums. Whether you’re preparing for a
special occasion or simply want a fresher, more radiant smile, our customized whitening
solutions can help you achieve the bright, confident look you deserve.`,
  },
  {
    id: 11,
    title: "Cosmetic Dentistry and Smile Makeovers",
    slug:"cosmetic-dentistry",
    image: cosmeticImg,
    description: `Cosmetic dentistry and smile makeovers are designed to enhance the appearance of your
teeth and create a smile that truly reflects your confidence and personality. Whether you’re
looking to correct discoloration, chipped or uneven teeth, gaps, or alignment issues, we offer a
range of advanced cosmetic treatments — including veneers, bonding, teeth whitening, and
contouring — tailored to your unique needs. At our clinic, we combine artistic precision with
modern dental technology to design a smile that looks natural, balanced, and beautiful. Every
smile makeover begins with a personalized consultation, where we understand your goals and
craft a treatment plan that brings your dream smile to life with comfort, care, and lasting results.`,
  },
  {
    id: 12,
    title: "Full Mouth Rehabilitation",
    slug: 'veneers-laminates',
    image: fullMouthRehabImg,
    description: `Full mouth rehabilitation is a comprehensive dental treatment designed to restore the health,
function, and aesthetics of your entire mouth. This personalized approach addresses multiple
dental issues, such as worn, damaged, or missing teeth, bite problems, and gum disease,
combining restorative and cosmetic procedures to achieve optimal results. At our clinic, we
develop a customized treatment plan that may include crowns, bridges, implants, dentures, and
other advanced solutions to rebuild your smile and improve oral function. Our goal is to help you
regain comfort, confidence, and a fully functional, beautiful smile, ensuring long-lasting results
and a healthier mouth overall.`,
  },
  {
    id: 13,
    title: "Digital Dentistry",
    slug: "digital-dentistry",
    image: digitalDentistryImg,
    description: `Digital dentistry uses the latest technology to make dental treatments more precise, efficient,
and comfortable. From digital impressions and 3D imaging to computer-aided design and milling
of crowns, bridges, and aligners, these innovations allow us to plan and execute treatments with
exceptional accuracy. At our clinic, digital dentistry helps us provide faster diagnoses,
customized restorations, and minimally invasive procedures, ensuring a smoother and more
predictable dental experience. By combining advanced technology with personalized care, we
can deliver high-quality results that enhance both the function and appearance of your smile.`,
  },
  {
    id: 14,
    title: "Laser Dentistry",
    slug:"laser-desntistry",
    image: laserDentistryImg,
    description: `Laser dentistry is a modern, minimally invasive approach that uses advanced laser technology
to treat a variety of dental conditions with precision and comfort. It can be used for procedures
such as gum reshaping, gum pigmentation removal, cavity treatment, and soft tissue surgeries,
often reducing pain, bleeding, and recovery time compared to traditional methods. At our clinic,
we utilize laser dentistry to provide gentle, accurate, and efficient care, ensuring that each
procedure is as comfortable as possible. This technology allows us to enhance treatment
outcomes while helping you achieve a healthier, more confident, and aesthetically pleasing
smile.`,
  },
];

export default ServiceDetailsData;
